import i18n from "i18next";
import k from "src/i18n/keys";

import { useMemo, type ReactElement } from "react";
import { Grid, GridItem } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import Section from "./Section";
import EmptyPlaceholder from "./EmptyPlaceholder";

import { getHomescreenSections, getLastOrgName } from "src/reducers";
import { formatSections } from "./utils";

import type { AppState, HomescreenSection } from "src/types";

const HomescreenGrid = (): ReactElement => {
  const sections = useSelector(({ app }: { app: AppState }) =>
    getHomescreenSections(app),
  );
  const orgTitle = useSelector(({ app }: { app: AppState }) =>
    getLastOrgName(app),
  );

  const {
    centerSections,
    rightSections,
  }: {
    centerSections: Array<HomescreenSection>;
    rightSections: Array<HomescreenSection>;
  } = useMemo(() => formatSections(sections), [sections]);

  return (
    <>
      {sections.length === 0 ? (
        <EmptyPlaceholder />
      ) : (
        <>
          <p>
            {i18n.t(k.HERE_S_WHAT_S_GOING_ON_AT)} {orgTitle}
          </p>
          {/* @ts-ignore Chakra UI types are creating problems */}
          <Grid templateColumns="repeat(10, 1fr)" gap={4}>
            {/* @ts-ignore Chakra UI types are creating problems */}
            <GridItem colSpan={6}>
              {centerSections.map((section) => (
                <Section key={section.id} section={section} />
              ))}
            </GridItem>

            <GridItem colSpan={4}>
              {rightSections.map((section) => (
                <Section key={section.id} section={section} />
              ))}
            </GridItem>
          </Grid>
        </>
      )}
    </>
  );
};

export default HomescreenGrid;
